import React from "react";
import ProfitReport from "./ProfitReport";

// Api/Reports/CategorywiseProfitReport - see ProfitReport.jsx
const CategoryWise = () => <ProfitReport kind="category" />;

export default CategoryWise;
